export const documentTypes = [
  {
    "documentTypeId": 40,
    "title": "General",
    "documentCategoryId": 2,
    "parentDocumentTypeId": null,
  },
]

export const documentCategories = [
  {
    "documentCategoryId": 2,
    "title": "Project",
    "parentDocumentCategoryId": null,
  },
  {
    "documentCategoryId": 3,
    "title": "Layer",
    "parentDocumentCategoryId": null,
  },
  {
    "documentCategoryId": 11,
    "title": "Tile service",
    "parentDocumentCategoryId": 3
  },
  {
    "documentCategoryId": 12,
    "title": "Extrusion",
    "parentDocumentCategoryId": 3
  },
  {
    "documentCategoryId": 14,
    "title": "DataView",
    "parentDocumentCategoryId": 3
  },
  {
    "documentCategoryId": 17,
    "title": "VectorTiles",
    "parentDocumentCategoryId": 3
  },
  {
    "documentCategoryId": 4,
    "title": "Vectorizari",
    "parentDocumentCategoryId": 3
  },
  {
    "documentCategoryId": 5,
    "title": "Ortofotoplan",
    "parentDocumentCategoryId": 3
  },
  {
    "documentCategoryId": 6,
    "title": "Heatmap",
    "parentDocumentCategoryId": 3
  },
  {
    "documentCategoryId": 59,
    "title": "Georeference",
    "parentDocumentCategoryId": 3
  },
  {
    "documentCategoryId": 106,
    "title": "DocumentsCollection",
    "parentDocumentCategoryId": 3
  },
  {
    "documentCategoryId": 107,
    "title": "MBTilesCollection",
    "parentDocumentCategoryId": 3
  },
  {
    "documentCategoryId": 135,
    "title": "Point cloud",
    "parentDocumentCategoryId": 3
  },
  {
    "documentCategoryId": 136,
    "title": "Folder",
    "parentDocumentCategoryId": 3
  },
  {
    "documentCategoryId": 138,
    "title": "Raster DEM",
    "parentDocumentCategoryId": 3
  },
  {
    "documentCategoryId": 176,
    "title": "Raster Video",
    "parentDocumentCategoryId": 3
  },
  {
    "documentCategoryId": 179,
    "title": "Raster Image",
    "parentDocumentCategoryId": 3
  },
  {
    "documentCategoryId": 194,
    "title": "OrganizationCollection",
    "parentDocumentCategoryId": 3
  }
]

export function prepareForSave(input, output) {
  if (Array.isArray(input)) {
    if (!output) output = [];
    for (let item of input) {
      output.push(prepareForSave(item))
    }
  } else {
    if (!output) output = {};
    for (let key in input) {
      if (typeof input[key] !== 'object') {
        output[key] = input[key];
      }
    }
    output['data'] = JSON.stringify(input);
  }
  console.log('prepareForSave', output)
  return output;
}

export function prepareForUse(input, output) {
  if (typeof input !== 'object') return input;
  if (Array.isArray(input)) {
    if (!output) output = [];
    for (let item of input) {
      output.push(prepareForUse(item, output))
    }
  } else {
    output = input;
    if (output.data) {
      output = {
        ...JSON.parse(output.data),
        ...output,
      }
      delete output.data;
    }
  }
  console.log('prepareForUse', output)
  return output;
}
